import * as bepolia from '@/assets/data/contracts/bepolia.json';
import { Pools } from '@/types/pools';

/*
 * FX Pool Factories
 *
 * @returns {Record<string, string>} - A record of quote token addresses to their corresponding FXPoolDeployer addresses.
 *
 * !Important: The FxPoolDeployer address must be in lower case.
 */
const fxPoolFactories = {};

const pools: Pools = {
  IdsMap: {},
  Pagination: {
    PerPage: 10,
    PerPool: 10,
    PerPoolInitial: 5,
  },
  BoostsEnabled: false,
  DelegateOwner: '0xba1ba1ba1ba1ba1ba1ba1ba1ba1ba1ba1ba1ba1b',
  ZeroAddress: '0x0000000000000000000000000000000000000000',
  DynamicFees: {
    Gauntlet: [],
  },
  BlockList: [
    '0x0f50d8acbd0b31e0d1ccb5ff4016874cbe606600000000000000000000000004',
    '0xca4f5c07bb649a260a75e5cc2e94e59db8d1f7b0000200000000000000000001',
    '0xd378277b2166f2d60d88e5bdf4c804cfffc1f11e000200000000000000000002',
    '0x5a994c938cd1c8edebce9b83feb0cea7e51323ec000000000000000000000003',
  ],
  IncludedPoolTypes: [
    'Weighted',
    // 'Stable',
    // 'MetaStable',
    // 'LiquidityBootstrapping',
    // 'Investment',
    // 'StablePhantom',
    'ComposableStable',
    'FX',
    // 'EulerLinear',
    // 'Gyro2',
    // 'Gyro3',
    // 'GyroE',
  ],
  Stable: {
    AllowList: [],
  },
  Investment: {
    AllowList: [],
  },
  Weighted: {
    // Only effective after given timestamp here: usePool.ts#createdAfterTimestamp
    // see useDisabledJoinPool.ts#nonAllowedWeightedPoolAfterTimestamp for logic.
    AllowList: [],
  },
  Factories: {
    [bepolia.WeightedPoolFactory]: 'weightedPool',
    [bepolia.ComposableStablePoolFactory]: 'composableStablePool',
    // append fxPoolFactories to the factories
    ...Object.fromEntries(
      Object.values(fxPoolFactories).map(factory => [factory, 'fx'])
    ),
  },
  Stakable: {
    VotingGaugePools: [],
    AllowList: [],
  },
  Metadata: {},
  Deep: [],
  BoostedApr: [],
  DisabledJoins: [], // may contain pool ids with security issues
  NewVersionAvailable: {},
  Deprecated: {}, // for pool migration?
  GaugeMigration: {},
  BrandedRedirect: {},
  ExitViaInternalBalance: [],
  Issues: {},
  FXPoolFactories: fxPoolFactories,
};

export default pools;
